var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 16C0.955556 16 0.638889 15.8722 0.383333 15.6167C0.127778 15.3611 0 15.0444 0 14.6667C0 14.2889 0.127778 13.9722 0.383333 13.7167C0.638889 13.4611 0.955556 13.3333 1.33333 13.3333H22.6667C23.0444 13.3333 23.3611 13.4611 23.6167 13.7167C23.8722 13.9722 24 14.2889 24 14.6667C24 15.0444 23.8722 15.3611 23.6167 15.6167C23.3611 15.8722 23.0444 16 22.6667 16H1.33333ZM1.33333 9.33333C0.955556 9.33333 0.638889 9.20556 0.383333 8.95C0.127778 8.69444 0 8.37778 0 8C0 7.62222 0.127778 7.30556 0.383333 7.05C0.638889 6.79445 0.955556 6.66667 1.33333 6.66667H22.6667C23.0444 6.66667 23.3611 6.79445 23.6167 7.05C23.8722 7.30556 24 7.62222 24 8C24 8.37778 23.8722 8.69444 23.6167 8.95C23.3611 9.20556 23.0444 9.33333 22.6667 9.33333H1.33333ZM1.33333 2.66667C0.955556 2.66667 0.638889 2.53889 0.383333 2.28333C0.127778 2.02778 0 1.71111 0 1.33333C0 0.955556 0.127778 0.638889 0.383333 0.383333C0.638889 0.127778 0.955556 0 1.33333 0H22.6667C23.0444 0 23.3611 0.127778 23.6167 0.383333C23.8722 0.638889 24 0.955556 24 1.33333C24 1.71111 23.8722 2.02778 23.6167 2.28333C23.3611 2.53889 23.0444 2.66667 22.6667 2.66667H1.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeBar);
export default __webpack_public_path__ + "static/media/threeBar.7a6af17eceda14734ab22dd4f644e103.svg";
export { ForwardRef as ReactComponent };